const routes = {
  reservations: 'Ordenes',
};

export default routes;
